var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, PCSS, CustomElement, Watch, Defaults, ViewChild, CustomTypedEvent, Components, CustomEventUtils, PropertyConverters, PropertyChangeEventName, Utils, Debounce, avoidHandler } from '@pacem/pacem-core';
import { Components as ComponentsUI } from '@pacem/pacem-ui';
import { PacemBaseElement } from './types-components';
import { FileUploadEventName } from './input-file';
import { SnapshotStep } from './snapshot';
//namespace Pacem.Components.Scaffolding {
export class Picture {
}
export const ImageFetchRequestEventName = 'imagefetchrequest';
export class ImageFetchRequestEvent extends CustomTypedEvent {
    constructor(args) {
        super(ImageFetchRequestEventName, args, { bubbles: true /*, scoped: false */ });
    }
}
let PacemEditImageElement = class PacemEditImageElement extends Components.PacemElement {
    constructor() {
        super(...arguments);
        this._index = 0;
        this.hint = '';
    }
    _uploaderPropertyChangedCallback(evt) {
        const val = evt.detail.currentValue;
        switch (evt.detail.propertyName) {
            case 'percentage':
                this._progressbar.percentage = val * 100.0;
                break;
            case 'uploading':
                if (val)
                    this._done(true);
                break;
        }
    }
    _thumbnailUploaderPropertyChangedCallback(evt) {
        const val = evt.detail.currentValue;
        switch (evt.detail.propertyName) {
            case 'percentage':
                this._progressbar.percentage = val * 100.0;
                break;
            case 'uploading':
                this._done(val);
                break;
        }
    }
    _uploaderFileUploadCallback(evt) {
        const uploader = this._uploader;
        const thumbUploader = this._thumbUploader, w = thumbUploader.maxImageWidth, h = thumbUploader.maxImageHeight;
        if (w > 0 && h > 0) {
            var blob = uploader.blob;
            const uid = evt.detail.uid;
            Utils.resizeImage(blob, w, h).then(blob2 => {
                if (blob2 != blob) {
                    thumbUploader.upload(blob2, 'thumbnail.jpg', uid);
                    return;
                }
                else
                    // fallback
                    this._done(false);
            });
        }
        else
            // fallback
            this._done(false);
    }
    _done(uploading) {
        if (!uploading) {
            this._imagefetch(0);
        }
        this._repeater.hidden = uploading;
        this._progressbar.hidden = !uploading;
    }
    _snapshotPropertyChangedCallback(evt) {
        switch (evt.detail.propertyName) {
            case 'value':
                const blob = Utils.dataURLToBlob(evt.detail.currentValue);
                this._uploader.upload(blob, 'snapshot.jpg');
                break;
        }
    }
    reset() {
        this._snapshot.step = SnapshotStep.Start;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'imageSet':
                let set = val || { skip: 0, set: [] };
                if (Utils.isNullOrEmpty(this._images) || set.skip === 0)
                    this._images = set.set;
                else if (!Utils.isNull(this._images))
                    Array.prototype.splice.apply(this._images, [set.skip, this._images.length - set.skip].concat(set.set));
                this._fetching = false;
                break;
            case 'hint':
                if (!first)
                    this._imagefetch(0);
                break;
        }
    }
    _imagefetchSuddenly(ndx) {
        this._fetching = true;
        this._imagefetch(ndx);
    }
    _imagefetch(ndx) {
        if (!(ndx >= 0))
            ndx = (this._images && this._images.length) || 0;
        this.dispatchEvent(new ImageFetchRequestEvent({ hint: this.hint, skip: ndx, take: 18 }));
    }
};
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemEditImageElement.prototype, "uploadUrl", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemEditImageElement.prototype, "hint", void 0);
__decorate([
    Watch()
], PacemEditImageElement.prototype, "imageSet", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemEditImageElement.prototype, "value", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemEditImageElement.prototype, "maxWidth", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemEditImageElement.prototype, "maxHeight", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemEditImageElement.prototype, "maxThumbnailWidth", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Number })
], PacemEditImageElement.prototype, "maxThumbnailHeight", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemEditImageElement.prototype, "allowSnapshot", void 0);
__decorate([
    Watch()
], PacemEditImageElement.prototype, "_fetching", void 0);
__decorate([
    Watch()
], PacemEditImageElement.prototype, "_images", void 0);
__decorate([
    ViewChild(P + '-repeater')
], PacemEditImageElement.prototype, "_repeater", void 0);
__decorate([
    ViewChild(P + '-upload[main]')
], PacemEditImageElement.prototype, "_uploader", void 0);
__decorate([
    ViewChild(P + '-upload[thumb]')
], PacemEditImageElement.prototype, "_thumbUploader", void 0);
__decorate([
    ViewChild(P + '-snapshot')
], PacemEditImageElement.prototype, "_snapshot", void 0);
__decorate([
    ViewChild(P + '-progressbar')
], PacemEditImageElement.prototype, "_progressbar", void 0);
__decorate([
    Debounce(500)
], PacemEditImageElement.prototype, "_imagefetch", null);
PacemEditImageElement = __decorate([
    CustomElement({
        tagName: P + '-edit-image', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-panel class="${PCSS}-edit-image"
        css-class="{{ {'${PCSS}-snapshot': ::_snapshot.step != '${SnapshotStep.Start}', '${PCSS}-uploading': ::_uploader.uploading, '${PCSS}-upload-enabled': !Pacem.Utils.isNullOrEmpty(:host.uploadUrl), '${PCSS}-snapshot-enabled': !Pacem.Utils.isNullOrEmpty(:host.uploadUrl) && :host.allowSnapshot} }}">
        <div>
            <${P}-input-search value="{{ :host.hint, twoway }}"></${P}-input-search>
            <${P}-upload main pattern=".+\.(jpe?g|png|svg|ico)$" url="{{ :host.uploadUrl }}"
                    max-image-width="{{ :host.maxWidth }}" max-image-height="{{ :host.maxHeight }}"
                    on-${FileUploadEventName}=":host._uploaderFileUploadCallback($event)"
                    on-${PropertyChangeEventName}=":host._uploaderPropertyChangedCallback($event)" hide="{{ Pacem.Utils.isNullOrEmpty(:host.uploadUrl) || ::_thumbUploader.uploading }}"></${P}-upload>
            <${P}-upload thumb pattern=".+\.(jpe?g|png|svg|ico)$" url="{{ :host.uploadUrl }}" hide="{{ !::_thumbUploader.uploading  }}"
                    max-image-width="{{ :host.maxThumbnailWidth }}" max-image-height="{{ :host.maxThumbnailHeight }}"
                    on-${PropertyChangeEventName}=":host._thumbnailUploaderPropertyChangedCallback($event)"></${P}-upload>
            <${P}-button class="${PCSS}-snapshot" on-click="Pacem.avoidHandler($event); ::_snapshot.step = '${SnapshotStep.Taking}'" hide="{{ Pacem.Utils.isNullOrEmpty(:host.uploadUrl) || !:host.allowSnapshot }}"></${P}-button>
            <${P}-infinite-scroller container="{{ ::_repeater }}" on-fetchmore=":host._imagefetchSuddenly()" disabled="{{ :host._fetching || :host.disabled || :host._images.length >= :host.imageSet.total }}"></${P}-infinite-scroller>
            <${P}-repeater datasource="{{ :host._images }}">
                <template>
                    <${P}-img css-class="{{ {'${PCSS}-selected': ^item.src === :host.value } }}" on-click=":host.value = ^item.src" src="{{ ^item.thumb }}" adapt="contain"></${P}-img>
                </template>
            </${P}-repeater>
            <${P}-progressbar class="progressbar-smaller progressbar-accent" caption="{{ ::_thumbUploader.uploading ? 'thumbnail...' : 'uploading...' }}"></${P}-progressbar>
        </div>
        <div>
            <${P}-snapshot hide="{{ !:host.allowSnapshot }}" on-${PropertyChangeEventName}=":host._snapshotPropertyChangedCallback($event)"></${P}-snapshot>
        </div>
    </${P}-panel>`
    })
], PacemEditImageElement);
export { PacemEditImageElement };
let PacemImageInputElement = class PacemImageInputElement extends PacemBaseElement {
    constructor() {
        super(...arguments);
        this._broadcastFetchRequestEventName = (evt) => {
            this.dispatchEvent(new ImageFetchRequestEvent(evt.detail));
        };
        this._innerValueChangedHandler = (evt) => {
            if (evt.detail.propertyName === 'value' && !Utils.isNull(this._dialog))
                this._dialog.state = evt.detail.currentValue;
        };
        // #endregion
    }
    convertValueAttributeToProperty(attr) {
        return attr; // better assumptions anyone?
    }
    getViewValue(value) {
        return value;
    }
    get inputFields() {
        return [];
    }
    _clear(evt) {
        this.changeHandler(evt);
    }
    onChange(evt) {
        let value = this.value;
        if (CustomEventUtils.isInstanceOf(evt, ComponentsUI.UI.DialogResultEvent)
            && evt.detail.button === ComponentsUI.UI.DialogButton.Ok)
            value = this.value = evt.detail.state;
        else if (evt.target === this._input)
            value = this.value = this._input.value;
        else if (evt.target === this._clearBtn)
            value = this.value = undefined;
        return Utils.fromResult(value);
    }
    toggleReadonlyView(readonly) {
        this._input.hidden = this._editBtn.hide = this._clearBtn.hide = readonly;
    }
    _addDialog() {
        var dialog = document.createElement(P + '-dialog');
        dialog.buttons = ComponentsUI.UI.DialogButtons.OkCancel;
        dialog.addEventListener(ComponentsUI.UI.DialogResultEventName, this.changeHandler, false);
        dialog.appendChild(this._addEditImage());
        document.body.appendChild(dialog);
        //
        return this._dialog = dialog;
    }
    _removeDialog() {
        this._removeEditImage();
        if (!Utils.isNull(this._dialog)) {
            this._dialog.removeEventListener(ComponentsUI.UI.DialogResultEventName, this.changeHandler, false);
            this._dialog.remove();
        }
    }
    _addEditImage() {
        var editImage = document.createElement(P + '-edit-image');
        editImage.disabled = true;
        editImage.addEventListener(PropertyChangeEventName, this._innerValueChangedHandler, false);
        editImage.addEventListener(ImageFetchRequestEventName, this._broadcastFetchRequestEventName, false);
        editImage.uploadUrl = this.uploadUrl;
        editImage.allowSnapshot = this.allowSnapshot;
        editImage.maxWidth = this.maxWidth;
        editImage.maxHeight = this.maxHeight;
        editImage.maxThumbnailHeight = this.maxThumbnailHeight;
        editImage.maxThumbnailWidth = this.maxThumbnailWidth;
        return this._editImage = editImage;
    }
    _removeEditImage() {
        if (!Utils.isNull(this._editImage)) {
            this._editImage.removeEventListener(PropertyChangeEventName, this._innerValueChangedHandler, false);
            this._editImage.removeEventListener(ImageFetchRequestEventName, this._broadcastFetchRequestEventName, false);
        }
    }
    connectedCallback() {
        super.connectedCallback();
        this._addDialog();
    }
    disconnectedCallback() {
        this._removeDialog();
        super.disconnectedCallback();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'uploadUrl':
                if (!Utils.isNull(this._editImage))
                    this._editImage.uploadUrl = val;
                break;
            case 'allowSnapshot':
                if (!Utils.isNull(this._editImage))
                    this._editImage.allowSnapshot = val;
                break;
            case 'imageSet':
                if (!Utils.isNull(this._editImage))
                    this._editImage.imageSet = val;
                break;
            case 'maxThumbnailHeight':
                if (!Utils.isNull(this._editImage))
                    this._editImage.maxThumbnailHeight = val;
                break;
            case 'maxThumbnailWidth':
                if (!Utils.isNull(this._editImage))
                    this._editImage.maxThumbnailWidth = val;
                break;
            case 'maxHeight':
                if (!Utils.isNull(this._editImage))
                    this._editImage.maxHeight = val;
                break;
            case 'maxWidth':
                if (!Utils.isNull(this._editImage))
                    this._editImage.maxWidth = val;
                break;
        }
    }
    acceptValue(val) {
        if (!Utils.isNull(this._editImage))
            this._editImage.value = val;
    }
    _update(val) {
        this._image.src = val;
    }
    _retrieve() {
        return this.value;
    }
    _edit(evt) {
        avoidHandler(evt);
        var editImage = this._editImage, state = this.value;
        editImage.disabled = false;
        editImage.reset();
        editImage.value = state;
        this._dialog.open(state).then(args => {
            switch (args.button) {
                case ComponentsUI.UI.DialogButton.Cancel:
                    // reset value
                    this._update(this.value);
                    break;
                case ComponentsUI.UI.DialogButton.Ok:
                    // save
                    this._update(args.state);
                    break;
            }
            this._editImage.disabled = true;
        });
    }
};
__decorate([
    ViewChild(P + '-img')
], PacemImageInputElement.prototype, "_image", void 0);
__decorate([
    ViewChild(P + '-button.' + PCSS + '-edit')
], PacemImageInputElement.prototype, "_editBtn", void 0);
__decorate([
    ViewChild(P + '-button.' + PCSS + '-clear')
], PacemImageInputElement.prototype, "_clearBtn", void 0);
__decorate([
    ViewChild(P + '-input-url')
], PacemImageInputElement.prototype, "_input", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemImageInputElement.prototype, "uploadUrl", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemImageInputElement.prototype, "imageSet", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemImageInputElement.prototype, "maxWidth", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemImageInputElement.prototype, "maxHeight", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemImageInputElement.prototype, "maxThumbnailWidth", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemImageInputElement.prototype, "maxThumbnailHeight", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemImageInputElement.prototype, "allowSnapshot", void 0);
PacemImageInputElement = __decorate([
    CustomElement({
        tagName: P + '-input-image', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<div class="${PCSS}-input-image"><${P}-img src="{{ :host.value }}" adapt="contain"></${P}-img><div class="${PCSS}-input-image-dashboard">
    <${P}-button on-click=":host._edit($event)" hide="{{ :host.disabled }}" class="${PCSS}-edit">Edit</${P}-button>
    <${P}-button on-click=":host._clear($event)" hide="{{ :host.disabled }}" class="${PCSS}-clear">Clear</${P}-button>
</div><${P}-input-url placeholder="{{ :host.placeholder }}" on-change=":host.changeHandler($event)" value="{{ :host.value }}"></${P}-input-url>

    <${P}-panel hide="{{ Pacem.Utils.isNullOrEmpty(:host.value) }}">
    <dl class="${PCSS}-input-image-preview">
        <dt>dimensions:</dt><dd><${P}-text text="{{ ::_image.size.width +'x'+ ::_image.size.height }}"></${P}-text></dd>
        <dt>size:</dt><dd><${P}-text text="{{ $pacem.size(::_image.size.weight) }}"></${P}-text></dd>
    </dl></${P}-panel>

</div>`
    })
], PacemImageInputElement);
export { PacemImageInputElement };
